import utils from 'utils'
import fullEleInvoiceIsAbnormalConfig from './fieldConfig'
import riskWarningModal from '../fullEleInvoice/view/riskWarningModal.html'
import fullEleInvoiceChooseUkeyModal from '../openedFullEleInvoice/view/openedFullEleInvoiceChooseUkeyModal.html'

export default class fullEleInvoiceIsAbnormalListCtrl {
    constructor($scope, $uibModal, logger, httpRequest, $state, sweetalert, initSortService, composeService, $location) {
        $scope.selectedRows = []
        $scope.customizedConfig = fullEleInvoiceIsAbnormalConfig
        $scope.queryParam = {
            pageNum: 1,
            pageSize: 10,
            param: {},
        }
        const pathParam = $location.path().replace(/\//g, '-')
        $scope.orderMap = initSortService(pathParam)
        $scope.queryParam.orderMap = $scope.orderMap.wrap
        const initDict = () => {
            const dictTypeArr = ['operation_type', 'manage_type', 'invoice_source', 'pool_inv_type', 'specific_element', 'invoice_status', 'is_download', 'send_status', 'department_no']
            httpRequest.get_dictByTypeArr(JSON.stringify(dictTypeArr)).then((res1) => {
                $scope.dictData = res1.data.value
            })
        }
        const getBelleRegion = () => {
            // 百丽--获取地区时两个参数都不传，获取管理城市时两个都要传--百丽接口
            httpRequest.get_getBelleRegion().then((res) => {
                $scope.belleRegionList = res.data.value
            })
        }
        const getAllTaxBureau = () => {
            // 获取所有主管税局信息
            httpRequest.get_getAllTaxBureau(localStorage.getItem('id_token')).then((res) => {
                $scope.dictDataProvince = res.data.value
            })
        }
        /**
         * @description: 接口来源的开票失败订单E税云界面开票权限开关参数是否开启
         * @param {*} httpRequest
         */
        const invoicPermissions = () => {
            httpRequest.get_getSysParam('batch_invoice_permission_conf').then((res) => {
                $scope.invoicPermissions = res.data.value.paramValue == 0 ? false : true
            })
        }
        $scope.reset = function () {
            $scope.queryParam.param = {}
        }
        //查询功能，和表头排序功能
        const queryList = () => {
            httpRequest
                .post_findErrorListByPage($scope.queryParam)
                .then((res) => {
                    let result = res.data.value
                    $scope.dataList = result.list
                    $scope.totalItems = result.total
                    $scope.queryParam.pageNum = result.pageNum
                    $scope.selectedRows = []
                })
        }
        $scope.init = composeService(queryList, invoicPermissions, getAllTaxBureau, initDict, getBelleRegion)
        $scope.init()
        $scope.selectedHandle = function () {
            $scope.queryParam.orderMap = $scope.orderMap.wrap
            queryList()
        }
        $scope.search = function () {
            queryList()
        }
        $scope.pageChanged = function () {
            queryList()
        }
        $scope.tableDropdownConfig = [
            {
                label: '重试',
                handler(item) {
                    $scope.batchRetries([item]);
                },
                showWhile(item, hasPermit) {
                    return hasPermit('retry')
                    // return true
                },
            },
        ]
        $scope.batchDropdownConfig = {
            btnText: '批量操作',
            options: [
                {
                    text: '批量重试',
                    hasPermit: 're_trigger',
                    handler() {
                        $scope.batchRetries($scope.selectedRows);
                    },
                },
            ],
        };
        $scope.batchRetries = (list) => {
            let errorIdList = []
            let invoiceIdList = []
            if (!$scope.invoicPermissions) {
                let isPOrt = list.some(item => item.invoiceSource == 'interface');
                if(isPOrt) return logger.logError('所选发票来源存在接口，不允许重试开票需要业务系统触发。')
            }
            list.forEach(el => {
                el.errorId ? errorIdList.push(el.errorId) : invoiceIdList.push(el.invoiceId)
            });
            let param = {
                errorIdList,
                invoiceIdList
            }
            console.log(param)
            httpRequest.post_retryg(param, '重试成功').then((res) => {
                queryList()
            })
            // const hasErrorIdList = list.filter(item => item.errorId !== null);
            // let noErrorIdList
            // if(!$scope.invoicPermissions) {
            //     noErrorIdList = list.filter(item => item.errorId == null && item.invoiceSource !== 'interface');
            // }else {
            //     noErrorIdList = list.filter(item => item.errorId == null);
            // }
            // const errorIds = hasErrorIdList.map((x) => { if (x.errorId) return x.errorId }).map(String)
            // sweetalert.confirm('批量重试提示', `当前发票数据可重试${errorIds.length}条，不可重试${noErrorIdList.length}条，确认后可点击【确定】进行批量重试且不可重试将进行开票。确定继续重试？`).then(() => {
            //     if (errorIds.length) {
            //         httpRequest.post_retryg(errorIds, '重试成功').then((res) => {
            //             openBatchBill(noErrorIdList)
            //             // queryList()
            //         })
            //     } else {
            //         openBatchBill(noErrorIdList)
            //     }
            // }, () => {
            //     console.log('取消')
            // })
        }
        $scope.exportExel = function exportExel() {
            let _url = `${host.etcloudOvat
                }tax4/ovatTax4ElecErrorLog/export?accessToken=${localStorage.getItem(
                    'id_token'
                )}`
            utils.file_download(
                _url,
                {},
                '', //type
                'POST',
                'blob',
                '',
                false
            )
        }
        $scope.InvFailureCallback = function() {
            if(!$scope.selectedRows.length) return logger.logError('请选择数据')
            let invoiceIdList = $scope.selectedRows.map((el) => el.invoiceId)
            httpRequest.post_tax4Callback(invoiceIdList).then((res) => {
                logger.logSuccess(res.data.message)
            })
        }
        async function openBill(item) {
            if (!$scope.invoicPermissions && Object.is(item.invoiceSource, 'interface')) {
                return logger.logError('数据来源为“接口”且开票状态为“失败”的发票限制手工开具，请业务系统源头发起')
            }
            if (item.isRed == "0") {
                let ukeyId = ''
                //发票的开票状态为【开票失败】，点击行按钮【开票】，不再弹出“选择开票点”弹窗，弹出提示弹窗
                if (item.openStatus == '2') {
                    sweetalert.confirm('提示', '当前发票上一次开票失败，只能按照原开票点' + item.ukeyCode + '提交开票，若要修改开票点，请回退后重新开票，是否确认开票？').then(() => {
                        invoiceOpenBefore(item, ukeyId)
                    }, () => {
                        console.log('取消')
                    })
                } else {
                    ukeyId = await chooseUkey('开具全电发票', '您正在进行将全电发票开具的操作，开具成功后，发票会自动流转至已开全电发票')
                }
                if (ukeyId) {
                    await invoiceOpenBefore(item, ukeyId)
                } else {
                    console.log('取消')
                }
            } else {
                oneInvoiceOpen(item)
            }
        }
        async function openBatchBill(list) {
            if (!list.length) return
            const result = check(list)
            if (!result) {
                return
            }
            const invoiceIds = list.map((ele) => {
                return ele.invoiceId
            })
            $scope.openBillListData = list
            let blueInvoice = list.filter((el) => el.isRed == '0')
            let redInvoice = list.filter((el) => el.isRed != '0')
            if (blueInvoice.length > 0 && redInvoice.length > 0) {
                logger.logError('全电蓝票和全电红票不可同时批量提交，请核对数据，将蓝票和红票分别提交开票。')
                return
            }
            if (blueInvoice.length > 0) {
                const ukeyId = await chooseUkey('开具全电发票', '您正在进行将全电发票开具的操作，开具成功后，发票会自动流转至已开全电发票')
                if (ukeyId) {
                    // await httpRequest.post_batchUpdateWaitInvUkeyId({
                    //     invoiceIdList: invoiceIds,
                    //     ukeyId,
                    // })
                    utils.loading('系统正在处理中，请耐心等待... ')
                    httpRequest.post_specialGetMatchInvoice(invoiceIds).then((res) => {
                        utils.loaded()
                        if (res.data.value.flag == '1') {
                            sweetalert.confirm('重复开票风险提示', '批量开票的发票中，存在上一次开票失败的发票，再次开票可能存在重复开票风险，请前往电子税局查看是否已开票。如实际未开票成功，确认后可点击【确定】重新提交开票请求进行开票。确定继续开票？').then(() => {
                                batchInvoiceOpen(invoiceIds)
                            }, () => {
                                console.log('取消')
                            })
                        } else {
                            batchInvoiceOpen(invoiceIds)
                        }
                    })
                } else {
                    console.log('取消')
                }
            }
            if (redInvoice.length > 0) {
                utils.loading('系统正在批量处理中，请耐心等待... ')
                httpRequest.post_tax4SpecialBatchInvoice({ invoiceIds: invoiceIds }).then((res) => {
                    utils.loaded()
                    const data = res.data.value
                    if (res.data.value.error > 0) {
                        $scope.showOpenErrorModal(data)
                        return
                    } else {
                        logger.logSuccess(`本次共计提交${data.total}条数据，成功${data.success}条，失败${data.error}条。`)
                    }
                    queryList()
                })
            }
        }
        // 开票前置
        function invoiceOpenBefore(item, ukeyId) {
            //  httpRequest.post_batchUpdateWaitInvUkeyId({
            //     invoiceIdList: [item.invoiceId],
            //     ukeyId,
            // })
            utils.loading('系统正在处理中，请耐心等待... ')
            let getListApi = 'post_ordinaryGetMatchInvoice'
            if (item.invoiceType == 62) {
                getListApi = 'post_specialGetMatchInvoice'
            }
            httpRequest[getListApi]([item.invoiceId]).then((res) => {
                utils.loaded()
                if (res.data.value.invoices.length > 0) {
                    $uibModal
                        .open({
                            template: riskWarningModal,
                            controller: 'riskWarningModalCtrl',
                            backdrop: 'static',
                            openedClass: 'mod-modal mod-modal-too-hg',
                            resolve: {
                                items1() {
                                    return {
                                        value: 1,
                                        invoiceList: res.data.value.invoices
                                    }
                                },
                            },
                        })
                        .result.then(
                            (data) => {
                                if (data === '关联') {
                                    queryList()
                                } else if (data) {
                                    oneInvoiceOpen(item)
                                }
                            },
                        )
                } else if (res.data.value.flag == '1') {
                    sweetalert.confirm('重复开票风险提示', '当前发票数据上一次开票失败，请前往电子税局查看是否已开票成功。如实际已开票成功，请进行手工关联，避免重复开票；如实际未开票成功，确认后可点击【确定】重新提交开票请求进行开票。确定继续开票？').then(() => {
                        oneInvoiceOpen(item)
                    }, () => {
                        console.log('取消')
                    })
                } else {
                    oneInvoiceOpen(item)
                }
            })
        }
        // 单张开票
        function oneInvoiceOpen(item) {
            let getListApi = 'post_tax4OrdinaryInvoice'
            if (item.invoiceType == 62) {
                getListApi = 'post_tax4SpecialInvoice'
            }
            utils.loading('开票中，请耐心等待')
            httpRequest[getListApi](item.invoiceId).then((res) => {
                logger.logSuccess('请求成功，请稍后查看。')
                queryList()
            })
        }
        // 批量开票
        function batchInvoiceOpen(invoiceIds, index, successNum, errorNum) {
            let i = index ? index : 0
            let total = invoiceIds.length
            let success = successNum ? successNum : 0
            let error = errorNum ? errorNum : 0
            // let getListApi = 'post_tax4OrdinaryBatchInvoice'
            // if ($scope.active === 2) {
            //     getListApi = 'post_tax4SpecialBatchInvoice'
            // }
            function getListApi() {
                let billData = $scope.openBillListData.filter((el) => el.invoiceId == invoiceIds[i])[0]
                if (billData.invoiceType == 61) {
                    return 'post_tax4OrdinaryBatchInvoice'
                } else {
                    return 'post_tax4SpecialBatchInvoice'
                }
            }
            utils.loading(`当前执行批量开票的发票份数为${total}张，正在开具第 ${i + 1} 张发票`)
            $scope.isCon = false
            httpRequest[getListApi()]({ invoiceIds: [invoiceIds[i]] }).then((res) => {
                if (res.data.value.error === 1) error++
                if (res.data.value.success === 1) success++
                i++
                if (i !== total) {
                    batchInvoiceOpen(invoiceIds, i, success, error)
                } else {
                    utils.loaded()
                    logger.logMsg({
                        title: '操作结果',
                        icon: 1,
                        message: `共计${total}张发票,成功${success}张，失败${error}张！开具成功的发票请到【已开全电票】列表查看`,
                    })
                }
                $scope.isCon = true
            }).finally(() => {
                if (!$scope.isCon) {
                    utils.loaded()
                    logger.logMsg({
                        icon: 1,
                        message: `当前执行批量开票的发票份数为${total}张，开票任务因异常原因：系统异常 已中断，已开票 ${success} 张发票。`,
                    })
                }
                queryList()
            })
        }
        function chooseUkey(title, tips) {
            return $uibModal
                .open({
                    template: fullEleInvoiceChooseUkeyModal,
                    controller: 'fullEleInvoiceChooseUkeyModal',
                    backdrop: 'static',
                    openedClass: 'mod-modal mod-modal-lg',
                    resolve: {
                        items1() {
                            return { title, tips }
                        },
                    },
                })
                .result.then(
                    (ukeyId) => {
                        return ukeyId
                    },
                    () => {
                        return ''
                    }
                )
        }
        function check(invoiceList, isPrint) {
            const userInfo = JSON.parse(localStorage.getItem('user_info'))
            if (userInfo.sale.taxplayerType === '3' || userInfo.sale.taxplayerType === '4' || userInfo.sale.taxplayerType === '9') {
                logger.logError('您所在企业纳税人类型不具备开票资格')
                return false
            }
            const hasErrorList = []
            for (let i = 0; i < invoiceList.length; i++) {
                if (!invoiceList[i].authMap.WAIT_BILLING) {
                    logger.logError('您选择的数据中有非“审批通过”状态的数据或"开具中"的数据，不能开票，请重新选择')
                    return false
                }
                if (invoiceList[i].invoiceResultDesc) {
                    hasErrorList.push({
                        infoId: invoiceList[i].waitId,
                        errorMsg: invoiceList[i].invoiceResultDesc,
                    })
                }
            }
            return hasErrorList
        }
    }
}
fullEleInvoiceIsAbnormalListCtrl.$inject = ['$scope', '$uibModal', 'logger', 'httpRequest', '$state', 'sweetalert', 'initSortService', 'composeService', '$location']



// WEBPACK FOOTER //
// ./src/app/outputManage/fullElectricInvoice/fullEleInvoiceIsAbnormal/list.js